<div class="p-4">
    <div class="container"> 
<!-- <div>
     <div> -->
            <router-outlet></router-outlet>
        
    </div>
</div>
